module.exports = __webpack_public_path__ + "static/media/lannister_token.2b6f1825.png";